import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    cell: {
        paddingBottom: '5px',
        paddingLeft: 4,
        paddingRight: 0,
        paddingTop: '5px',
        textAlign: 'center',
        width: '9%'
    },
    cellContent: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around'
    },
    urlIcon: {
        color: theme.palette.orange.light,
        cursor: 'pointer',
        fontSize: 'large'
    },
    disabledIcon: {
        color: theme.palette.grey.light,
        cursor: 'auto'
    },
    goodIcon: {
        color: theme.palette.green.main
    },
    hoverPriceCellContent: {
        '&:hover': {
            backgroundColor: theme.palette.grey.ultralight
        },
        cursor: 'pointer'
    },
    icon: {
        color: theme.palette.grey.semidark,
        cursor: 'pointer',
        fontSize: 'large'
    },
    iconCell: {
        paddingLeft: 4,
        paddingRight: 0,
        textAlign: 'center',
        width: '4%',
        paddingBottom: '5px',
        paddingTop: '5px'
    },
    lastCell: {
        maxWidth: '20px',
        paddingLeft: 4,
        paddingRight: 0
    },
    marketPlaceStock: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        fontSize: '0.9em',
        justifyContent: 'center'
    },
    nvBellIcon: {
        color: theme.palette.blue.main
    },
    paramsIcon: {
        //color: theme.palette.orange.light,
        cursor: 'pointer',
        fontSize: 'large'
    },
    price: {
        marginRight: '4px'
    },
    priceCellContent: {
        alignItems: 'center',
        borderRadius: '3px',
        display: 'flex',
        height: '43px',
        justifyContent: 'space-around',
        width: '85px'
    },
    productName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    productNameCell: {
        paddingRight: 0,
        width: '25%',
        paddingBottom: '15px',
        paddingTop: '15px'
    },
    productNameCellContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around'
    },
    selectedPriceCellContent: {
        backgroundColor: theme.palette.green.ultralight,
        cursor: 'pointer'
    },
    table: {
        marginBottom: theme.spacing(2)
    },
    url: {
        color: theme.palette.grey.main,
        cursor: 'pointer',
        fontSize: 11,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '350px'
    },
    wrongIcon: {
        color: theme.palette.red.main
    }
}));

export default useStyles;
